export default "__VITE_ASSET__4ae1582f__"